function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke-miterlimit:10;stroke-width:15px;}.cls-1{stroke:#fff;}.cls-2{stroke:#63b99c;}.cls-3{stroke:#efb050;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M417.07,536.92c0,101.39-82.2,183.58-183.58,183.58S49.9,638.31,49.9,536.92s82.2-183.59,183.59-183.59",
  transform: "translate(-42.4 -345.83)"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 191.08,
  y1: 191.08,
  x2: 382.02,
  y2: 191.08
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 463.45,
  y1: 7.5,
  x2: 463.45,
  y2: 374.66
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M682.49,353.33c0,101.39-82.2,183.59-183.59,183.59",
  transform: "translate(-42.4 -345.83)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M499.12,536.92A183.58,183.58,0,0,1,682.7,720.5",
  transform: "translate(-42.4 -345.83)"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 778.21,
  cy: 276.02,
  r: 105.81
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 884.02,
  y1: 276.02,
  x2: 884.02,
  y2: 381.83
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 936.26,
  y1: 384.76,
  x2: 936.26,
  y2: 72.53
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 1005.54,
  y1: 146.89,
  x2: 866.52,
  y2: 146.89
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1076.27,734.52a105.81,105.81,0,1,1,211.61,0",
  transform: "translate(-42.4 -345.83)"
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 1033.86,
  y1: 388.55,
  x2: 1033.86,
  y2: 76.33
});

function SvgGkathLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1252.98 389.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGkathLogo);
export default __webpack_public_path__ + "static/media/gkath-logo.838c0b2e.svg";
export { ForwardRef as ReactComponent };